/*
 * @Author: soji
 * @Description: 描述
 * @Date: 2024-07-08 15:52:36
 */
/*
 * @Author: soji
 * @Description: 特殊要求选择工具
 * @Date: 2021-04-14 17:24:03
 */
console.log('specialUtil.js ...')
 
let specialUtil = {
  

  select(
    params = {
      type: 'standard', // standard propertys choices choiceList
      item: null,
      items: [],
      propertyItem: null,
      product: null,

      index: 0,
      groupIndex: 0,
      sendMode: 1,
      stockObj: null,
    }
  ) {

    let {type, item, items, product, stockObj} = params

    if(!type || !item || !items || !product) {
      throw 'item、items、type、product为必传字段'
    }

    // 检查库存
    let stockLen = specialUtil.countItemSelectLen(item, 1, product.count, false)
    let calStockObj = item.hasStock ? (item.pid ? stockObj.proStockMap[item.pid] : (item.refId ? stockObj.refSpecStockMap[item.refId] : stockObj.specialStockMap[item.uid])) : null;
    let calStock = calStockObj ? (calStockObj.tempStock + item.count) : item.stockNum;
    if(stockLen > 0 && calStock - stockLen < 0) {
      Com.$messager(`添加失败，【${item.name}】已超出库存`)
      return -1 // 操作被拦截了就返回-1
    }

    let strategy = new SpecialSelectUtil(params)
    return strategy.select();
  },

  initProSpecial(productV, order) {
    productV.count = 1;
    this.loopSpecialItems(productV, item => {
      // item.contextStockNum = item.stockNum;
      item.exclude = false; // 是否被互斥了？
    })
  },

  /**
   * 是否开启了库存
   * 参数item : items 下的 item
   * 
   *  */ 
  isUseStock(item) {
    return item.hasStock || false;
  },

  // 计算一个item占用多少个库存 useActive? 是否使用active字段参与计算
  countItemSelectLen (item, itemBeCount, proCount, useActive = true) {
    if(this.isUseStock(item) && (useActive ? item.active : true)) {
      let count = itemBeCount
      return Math.mul(count , proCount)
    }else {
      return 0
    }
  },

    /**
   * 获取该餐品的特殊要求items
   * @param {*} listRequirementsPro 有listRequirements字段的餐品
   */
  getListRequirementsItems(listRequirementsPro) {
    let items = [];
    (listRequirementsPro.listRequirements || []).map(listRequirementItem => {
      (listRequirementItem.propertys || []).map(property => {
        items.push(...property.items)
      })
    })
    return items;
  },

  /**
   * 获取该餐品的特殊要求items
   * @param {*} productGroupProduct 套餐接口getProductGroup返回的子餐品结构
   */
  getProductGroupProRequirementItems(productGroupProduct) {
    let allItems = this.getAllItems(productGroupProduct)
    return allItems;
  },

  /**
   * 更新餐品特殊要求的库存信息。
   * 在选择特殊要求、特殊要求和餐品增减数量后触发该函数。
   */
  updateContextStockNum(productV, tempStockObj) {
    let proCount = productV.count;
    let stockObj = this.deletTempStock(tempStockObj);
    this.loopSpecialItems(productV, item => {
      let countObj = {};
      if(this.isUseStock(item)) {
        countObj = item.pid ? stockObj.proStockMap[item.pid] : item.refId ? stockObj.refSpecStockMap[item.refId] : stockObj.specialStockMap[item.uid]
        if(typeof countObj.tempStock == 'undefined') {
          countObj.tempStock = countObj.restStock;
        }
      }
      let countStock = countObj ? countObj : item
      // 计算库存
      let countCount = this.countItemSelectLen(item, item.hasOwnProperty('count') ? item.count : 1, proCount);
      // item.contextStockNum = countStock - this.countItemSelectLen(item, item.hasOwnProperty('count') ? item.count : 1, proCount)
      countStock.tempStock = countObj.tempStock - countCount;
      if(countObj.tempStock < 0) {
        console.error('特殊要求的库存小于0了，请完善选择特殊要求的拦截逻辑')
      }
    })
  },

  deletTempStock(stockObj) {
    for (const key in stockObj.proStockMap) {
      let stock = stockObj.proStockMap[key];
      if(typeof stock.tempStock !== 'undefined') delete stock.tempStock;
    }
    for (const key in stockObj.refSpecStockMap) {
      let stock = stockObj.refSpecStockMap[key];
      if(typeof stock.tempStock !== 'undefined') delete stock.tempStock;
    }
    for (const key in stockObj.specialStockMap) {
      let stock = stockObj.specialStockMap[key];
      if(typeof stock.tempStock !== 'undefined') delete stock.tempStock;
    }
    return stockObj;
  },

  loopSpecialItems(pro, handleFn, needGroup = true) {
    if(!pro || !pro.property || !handleFn) return
    // 将items合成1维数组
    let getKeys = [
      {'standard': value => {
        value.items.map(i => {i.field = 'standard'; if(needGroup) i.group = value})
        return value.items
      }},
      {'propertys' : value => { 
          let items = [];
          value.map(item => {
            item.items.map(i => {i.field = 'propertys'; if(needGroup) i.group = item})
            items.push(...item.items)
          })
          return items
        } 
      },
      {'choices'   : value => {
        value.items.map(i => {i.field = 'choices'; if(needGroup) i.group = value})
        return value.items
      }},
      {'choiceList': value => { 
          let items = [];
          value.map(item => {
            item.items.map(i => {i.field = 'choiceList'; if(needGroup) i.group = item})
            items.push(...item.items)
          })
          return items
        } 
      },
    ]

    getKeys.map(getKey => {
      let field = Object.keys(getKey)[0]
      let specialValue = pro.property[field]
      if(specialValue) {
        let items = getKey[field](specialValue)
        for(let item of items) {
          handleFn(item)
        } 
      }
    })
  },

  // 检查特殊要求的选择是否合法
  checkSelect(pro, limitInOriginOrder = true, order, sendMode = 1, shoppingCartList) {
    let error = null;
    let pidMap = new Map(); // Map<pid, num>, num是原订单中的餐品选择数量
    let orderProducts = order.orderProducts || []
    orderProducts.map(pro => {
      if(pidMap.has(pro.pid)) {
        let existNum = pidMap.get(pro.pid)
        pidMap.set(pro.pid, existNum + pro.num)
      }else {
        pidMap.set(pro.pid, pro.num)
      }
    })

    let proMaxSelectNum = pidMap.get(pro.pid);
    if(sendMode == 2 && this.getActiveItems(pro).length == 0) {
      error = `至少选择一项`;
    }

    // 有规格要选规格
    if(pro.property && pro.property.standard && pro.property.standard.items) {
      let standardGroup = pro.property.standard
      if(sendMode == 1 && !standardGroup.items.some(item => item.active)) {
        error = `请选择${standardGroup.title || standardGroup.titleEn}`
      }
      if(standardGroup.items.some(item => item.active) && (proMaxSelectNum - this.checkGroupSpecInOrder(shoppingCartList, standardGroup.uid, pro) - pro.count < 0)) {
        error = `【${standardGroup.title}】- 最多${proMaxSelectNum}份噢`
      }
      
    }

    // 有属性要选属性
    if(!error && pro.property && pro.property.propertys && pro.property) {
      for(let i = 0; i < pro.property.propertys.length; i++) {
        let propertysGroup = pro.property.propertys[i]
        if(sendMode == 1 && !propertysGroup.items.some(item => item.active)) {
          error = `请选择${propertysGroup.title || propertysGroup.titleEn}`
          break
        }
        if(propertysGroup.items.some(item => item.active) && (proMaxSelectNum - this.checkGroupSpecInOrder(shoppingCartList, propertysGroup.uid, pro) - pro.count < 0)) {
          error = `【${propertysGroup.title}】- 最多${proMaxSelectNum}份噢`
          break
        }
      }
    }

    // 有多选需要判断是否超出份数
    if(pro.property && pro.property.choices && pro.property.choices.items) {
      let choiceGroup = pro.property.choices
      if(choiceGroup.items.some(item => item.active) && proMaxSelectNum - this.checkGroupSpecInOrder(shoppingCartList, choiceGroup.uid, pro) - pro.count < 0 ) {
        error = `【${choiceGroup.title}】- 最多${proMaxSelectNum}份噢`
      }
    }

    if(!error && pro.property && pro.property.choiceList) {
      for(const choice of pro.property.choiceList) {

        // 超过自身限制
        let overMaxNumItem = choice.items.find(item =>  item.active && (item.count + this.checkSpecialInOrder(shoppingCartList, item.uid, pro)) > item.maxSelectNum )
        if(overMaxNumItem) {
          error = `【${choice.title}】-【${overMaxNumItem.name}】请最多${overMaxNumItem.maxSelectNum}份噢`
          break
        }

        // 超过一组的总数限制
        let selectLen = 0  // 该组的选择总数量
        choice.items.map(item => {
          if(item.active) {
            selectLen += (item.count + this.checkSpecialInOrder(shoppingCartList, item.uid, pro))
          }
        })
        let maxLen = choice.maxMultipleChoiceNum || 99999999
        let minLen = choice.minRequiredNum || 0
        if((selectLen < minLen) && sendMode == 1) {
          error = `【${choice.title}】请至少${minLen}份噢`
        }else if(selectLen > maxLen) {
          error = `【${choice.title}】请最多${maxLen}份噢`
        }

        if(error) break
      }
    }

    if(!error && limitInOriginOrder) {

      let uidEnableMap = new Map() // <uid, [...]> uid对应可选的全部uid
      let selectUid = [];
      order.order.orderProducts.map(orPro => {
        let selectUidGroup = [];
        (orPro.listRequirements || []).map(req => {
          (req.propertys || []).map(property => {
            (property.items || []).map(item => {
              selectUidGroup.push(item.uid)
            })
          })
        })
        selectUid.push(selectUidGroup)
      })

      //
      let activeItems = this.getActiveItems(pro);
      // activeItems = activeItems.filter(item => item.field=='standard' || item.field=='propertys')

      let isInOrderSelectGroup = false
      for(let i = 0; i<selectUid.length; i++) {
        let selectGroup = selectUid[i]
        if(activeItems.every(actItem => selectGroup.includes(actItem.uid))) {
          isInOrderSelectGroup = true
          break
        }
      }
      // 检查规格跟属性的选择组合 是否合法。
      if(!isInOrderSelectGroup && sendMode == 1) {
        error = '原订单无该选择组合'
      }
      // 检查数量是否超出原订单数量
      if(!error) {
        // 检查是否超出原订单-特殊要求数量
        let noCountFields = ['standard', 'propertys', 'choices'];
        let proBeCount = pro.count
        let countMap = this.getUidMaxCountMapInOrder(pro, order, true)
        specialUtil.loopSpecialItems(pro, item => {
          if(!error && item.active) {
            let isOver = false;
            if(noCountFields.includes(item.field)) {
              if((proBeCount + this.checkSpecialInOrder(shoppingCartList, item.uid, pro))> countMap.get(item.uid)) {
                isOver = true
              }
            }else {
              if(((proBeCount * item.count) + this.checkSpecialInOrder(shoppingCartList, item.uid, pro)) > countMap.get(item.uid)) {
                isOver = true
              }
            }
            if(isOver) {
              error = `添加失败，【${item.name}】已超出原订单数量`
            }
          }
        })
      }



    }

    return error
  },
  checkSpecialInOrder(shoppingCartList, uid, pro) {
    // 购物车餐品信息
    let count = 0 ; // 特殊要求项在购物车中总的选中信息
    shoppingCartList.map(cartPro => {
      if(cartPro.unionId && cartPro.uid == uid && cartPro.propertyInfo.parentPid == pro.uid) { // 以单品形式加入购物车的特殊要求
        count += cartPro.count;
      } else if(cartPro.uid == pro.uid){
        let actItems = this.getActiveItems(cartPro).filter(activeItem => activeItem.uid == uid);
        actItems.map(actItem => {
          count += ((actItem.count || 1) * (cartPro.count || 1))
        })
      }
    })
    return count
  },

  checkGroupSpecInOrder(shoppingCartList, groupId, pro) { // 只算规格属性多选
    // 购物车餐品信息
    let count = 0 ; // 特殊要求项在购物车中总的选中信息
    shoppingCartList.map(cartPro => {
      if(cartPro.unionId && cartPro.group.uid == groupId && cartPro.propertyInfo.parentPid == pro.uid) { // 以单品形式加入购物车的特殊要求计算组数量
        count += cartPro.count;
      } else if(cartPro.uid == pro.uid){
        count += cartPro.count;
      }
    })
    return count
  },

  checkAllSpecialInOrder(shoppingCartList, order) {
    let error = ''

    // 购物车餐品信息
    let uidCountMap = new Map() // <uid, {count, item, pro}> , 特殊要求项总的选中信息
    shoppingCartList.map(pro => {
      if(pro.unionId) { // 需要加上以单品形式加入购物车的特殊要求
        if(uidCountMap.has(pro.uid)) {
          let obj = uidCountMap.get(pro.uid)
          obj.count += pro.count;
        }else {
          uidCountMap.set(pro.uid, {
            count: pro.count,
            item: pro,
          })
        }
      }
      let actItems = this.getActiveItems(pro)
      actItems.map(actItem => {
        if(uidCountMap.has(actItem.uid)) {
          let obj = uidCountMap.get(actItem.uid)
          obj.count += ((actItem.count || 1) * (pro.count || 1))
        }else {
          uidCountMap.set(actItem.uid, {
            count: (actItem.count || 1) * (pro.count || 1),
            item: actItem,
            pro: pro,
          })
        }
      })
    })
    // 检查购物车餐品总的特殊要求是否超过原订单数量
    for(let i=0; i<shoppingCartList.length; i++) {
      let pro = shoppingCartList[i]
      let uidMaxMap = this.getUidMaxCountMapInOrder(pro, order, true) // 订单中uid最大数量
      let noCountFields = ['standard', 'propertys', 'choices'];
      let proBeCount = pro.count
      specialUtil.loopSpecialItems(pro, item => {
        if(!error && item.active) { 
          let isOver = false;
          let uidInfo = uidCountMap.get(item.uid);
          let uidCount = uidInfo.count;
          if(noCountFields.includes(item.field)) {
            if(uidCount > uidMaxMap.get(item.uid)) {
              isOver = true
            }
          }else {
            if(uidCount > uidMaxMap.get(item.uid)) {
              isOver = true
            }
          }
          if(isOver) {
            error = `添加失败，【${pro.name}-${item.name}】总数已超出原订单数量`
          }
        }
      })
      if(error) {
        break
      }
    }


    if(error) {
      return {pass: false, tips: error}
    }else {
      return {pass: true, tips: ''}
    }


  },

  getUidMaxCountMapInOrder(pro,  order, isTotal = false) {
    let uidCountMap = new Map(); // <uid, count>
    let orPros = order.order.orderProducts.filter(orPro => pro.pid === orPro.pid)
    // 订单总数的限制如 A餐品[多组多选1 x 2]，A餐品[多组多选1 x ·，多组多选2 x 2]；
    // isTotal为true：A餐品[多组多选1]最多能选3个
    // isTotal为false：A餐品[多组多选1]最多能加到2个
    if(isTotal) {
      orPros.map(orPro => {
        (orPro.listRequirements || []).map(req => {
          (req.propertys || []).map(property => {
            (property.items || []).map(item => {
              if(uidCountMap.has(item.uid)) {
                let count = uidCountMap.get(item.uid)
                uidCountMap.set(item.uid, count + (item.num || 1) * (orPro.num || 1))
              }else {
                uidCountMap.set(item.uid,  (item.num || 1) * (orPro.num || 1))
              }
            })
          })
        })
      })
    }else {
      orPros.map(orPro => {
        (orPro.listRequirements || []).map(req => {
          (req.propertys || []).map(property => {
            (property.items || []).map(item => {
              if(uidCountMap.has(item.uid)) {
                let count = uidCountMap.get(item.uid)
                uidCountMap.set(item.uid, Math.max(count, (item.num || 1)) )
              }else {
                uidCountMap.set(item.uid,  (item.num || 1) )
              }
            })
          })
        })
      })
    }

    return uidCountMap
  },
  
  getUidMaxCountInOrder(pro, uid, order, isTotal = false) {
    let uidCountMap = this.getUidMaxCountMapInOrder(pro,  order, isTotal)
    return uidCountMap.get(uid)
  },

  
  // 特殊要求的选择结果唯一Key，用于对比选择结果是否相同。【跟顺序有关】
  getSpecialSelectKey(pro, key = 'uid', customGetKeys) {
    if(!pro.property) return null;
    // 将items合成1维数组
    let getKeys = [
      {'standard': value => value.items.filter(item => item.active).map(item => item[key]).join()},
      {'propertys' : value => { 
          let items = [];
          value.map(item => {
            items.push(...item.items)
          })
          return items.filter(item => item.active).map(item => item[key]).join()
        } 
      },
      {'choices'   : value => value.items.filter(item => item.active).map(item => item[key]).join() },
      {'choiceList': value => { 
          let items = [];
          value.map(item => {
            items.push(...item.items)
          })
          return items.filter(item => item.active).map(item => item[key] + 'x' + item.count).join()
        } 
      },
    ]
    if(customGetKeys) {
      getKeys = customGetKeys
    }

    // 特殊要求如何对比？将选择结果拼接成字符串作为key
    let resultKey = ''
    getKeys.map(getKey => {
      let field = Object.keys(getKey)[0]
      let specialValue = pro.property[field]
      resultKey += (specialValue ? (resultKey ? ',' : '' ) + getKey[field](specialValue) : '')
    })
    return resultKey
  },

  getAllItems(pro) {
    let list = []
    if(!pro.property) return []
    // 将items合成1维数组
    let getKeys = [
      {'standard': value => value.items.map(item => {item.field = 'standard';return item})},
      {'propertys' : value => { 
          let items = [];
          value.map(item => {
            items.push(...item.items)
          })
          return items.map(item => {item.field = 'propertys';return item})
        } 
      },
      {'choices'   : value => value.items.map(item => {item.field = 'choices';return item}) },
      {'choiceList': value => { 
          let items = [];
          value.map(item => {
            items.push(...item.items)
          })
          return items.map(item => {item.field = 'choiceList';return item})
        } 
      },
    ]

    getKeys.map(getKey => {
      let field = Object.keys(getKey)[0]
      let specialValue = pro.property[field]
      specialValue && list.push(...getKey[field](specialValue))
    })
    return list
  },

  formatActiveItem(item, pro, needGroupUid = false) {
    if(needGroupUid) {
      return {...item, group: item.group, unionId: `${pro.uid}-${item.group.uid}-${item.uid}-${item.pid}`}
    } else {
      return item;
    }
  },

  // 返回选中的item
  getActiveItems(pro, needGroupUid = false) {
    let list = []
    if(!pro.property) return []
    // 将items合成1维数组
    let getKeys = [
      {'standard': value => value.items.filter(item => item.active).map(item => {item.field = 'standard';item.group = value;return this.formatActiveItem(item, pro, needGroupUid) })},
      {'propertys' : value => { 
          let items = [];
          value.map(item => {
            item.items.forEach(i => {i.group = item})
            items.push(...item.items)
          })
          return items.filter(item => item.active).map(item => {item.field = 'propertys';return this.formatActiveItem(item, pro, needGroupUid)})
        } 
      },
      {'choices'   : value => value.items.filter(item => item.active).map(item => {item.field = 'choices';item.group = value;return this.formatActiveItem(item, pro, needGroupUid)}) },
      {'choiceList': value => { 
          let items = [];
          value.map(item => {
            item.items.forEach(i => {i.group = item})
            items.push(...item.items)
          })
          return items.filter(item => item.active).map(item => {item.field = 'choiceList';return this.formatActiveItem(item, items, needGroupUid)})
        } 
      },
    ]

    getKeys.map(getKey => {
      let field = Object.keys(getKey)[0]
      let specialValue = pro.property[field]
      specialValue && list.push(...getKey[field](specialValue))
    })
    return list
  },

  getSpecialSelectDesc(pro, key = 'name', separator = '/') {
    if(!pro.property) return ''
    // 将items合成1维数组
    let getKeys = [
      {'standard': value => value.items.filter(item => item.active).map(item => item[key]).join(separator)},
      {'propertys' : value => { 
          let items = [];
          value.map(item => {
            items.push(...item.items)
          })
          return items.filter(item => item.active).map(item => item[key]).join(separator)
        } 
      },
      {'choices'   : value => value.items.filter(item => item.active).map(item => item[key]).join(separator) },
      {'choiceList': value => { 
          let items = [];
          value.map(item => {
            items.push(...item.items)
          })
          return items.filter(item => item.active).map(item => item[key] + 'x' + item.count).join(separator)
        } 
      },
    ]

    // 特殊要求如何对比？将选择结果拼接成字符串作为key
    let resultKey = ''
    getKeys.map(getKey => {
      let field = Object.keys(getKey)[0]
      let specialValue = pro.property[field]
      resultKey += (specialValue ? (resultKey ? separator : '' ) + getKey[field](specialValue) : '')
    })
    if(resultKey.endsWith(separator)) {
      resultKey = resultKey.slice(0, -1);
    }
    return resultKey
  },

  // 返回接口需要的特殊要求选择格式
  getNetProperty(proProperty) {
    
    if(!proProperty) return []
    
    // 适合 结构: {title: '', items:[]}
    const getActiveListForObject = function(specialItem) {
      let activeItems = specialItem.items.filter(item => item.active).map(item => {
        let {uid, name, price,} = item
        return {uid, name, price}
      })
      return [{
        pid: specialItem.uid,
        items: activeItems
      }]
    }

    // 适合 结构: [{title: '', items:[]},{title: '', items:[]}items]
    const getActiveListForArray = function(specialItem) {
      let groups = []
      specialItem.map(groupItem => {
        let groupActiveList = [];
        let activeItems = groupItem.items.filter(item => item.active)
        groups.push({ pid: groupItem.uid, items: activeItems.map(item => {
            let {uid, name, price, count} = item
            let actItem = {uid, name, price,}
            if(count) {
              actItem.num = count
            }
            return actItem
          }),
        });
      })
      
      
      return groups
    }

    let propertyField = {
      standard              : {       name: '规格',      fn: getActiveListForObject,    },      // 结构: {title: '', items:[]}
      propertys             : {       name: '属性',      fn: getActiveListForArray,   },      // 结构: [{title: '', items:[]},{title: '', items:[]}]
      choices               : {       name: '多选',      fn: getActiveListForObject,     },      // 结构: {title: '', items:[]}
      choiceList            : {       name: '多组多选',  fn: getActiveListForArray,  },      // 结构: [{title: '', items:[]},{title: '', items:[]}] 
    }
    let specialSelectList = []
    for(const fieldKey of Object.keys(propertyField)) {
      let fieldVal = propertyField[fieldKey]
      let specialItem = proProperty[fieldKey]
      if(specialItem && fieldVal) {
        specialSelectList.push(...fieldVal.fn(specialItem))
      }
    }
    return specialSelectList || [];
  },

  //计算已选中的单品中特殊要求与当前计算的特殊要求中的单品一致的数量
  calItemSelectNum(pro, curTarget) {
    let items = this.getActiveItems(pro);
    let targetItem = items.filter(item => item.uid == curTarget.uid);
    if(targetItem.length) return (targetItem.count || 1)*pro.count;
    else return 0;
  },

  // 获取同组的选中项
  getSameGroupActiveItem(pro, curTarget) {
    let items = this.getActiveItems(pro).filter(item => item.group.uid == curTarget.group.uid);
    return items;
  },

  calGroupSelectNum(pro, curTarget){
    let items = this.getSameGroupActiveItem(pro, curTarget);
    if(items.length) return items.reduce((pre,cur) => {return pre+(cur.count||1)*pro.count}, 0)
    else return 0;
  }
 
}

class SpecialSelectUtil {
  static SELECT_TYPE = {
    standard              : {  fnName: 'standard',       name: '规格',  },      // 结构: {title: '', items:[]}
    propertys             : {  fnName: 'propertys',      name: '属性',  },      // 结构: [{title: '', items:[]},{title: '', items:[]}]
    choices               : {  fnName: 'choices',         name: '多选',  },      // 结构: {title: '', items:[]}
    choiceList            : {  fnName: 'choiceList',    name: '多组多选',  },  // 结构: [{title: '', items:[]},{title: '', items:[]}] 

  }


  constructor(params) {
    this.params = params
    this.item = params.item
    this.items = params.items
    this.propertyItem = params.propertyItem
    this.type = params.type
  }

  select() {
    let typeObj = SpecialSelectUtil.SELECT_TYPE[this.type]
    if(typeObj) {
      this[typeObj.fnName]()
    }else {
      console.error('该特殊要求类型未做添加进购物车的逻辑配置...')
    }
  }

  // 单选
  __singleSelect(canCancel = false, countBeZero = false) {
    if(!this.item.active) {
      this.items.map(item => {
        item.active = false
        if(countBeZero && item.hasOwnProperty('count')) {
          item.count = 0;
        }
      })
      this.item.active = true;
    }else {
      canCancel && (this.item.active = false)
    }
  }

 


  // 规格
  standard() {
    if(this.params.sendMode == 2) {
      this.__singleSelect(true, true)
      return;
    }
    if(this.item.active) return
    this.__singleSelect()
  }

  // 属性
  propertys() {
    if(this.params.sendMode == 2) {
      this.__singleSelect(true, true)
      return;
    }
    if(this.item.active) return
    this.__singleSelect()
  }

  // 多选
  choices() {
    this.item.active = !this.item.active;
  }

  // 多组多选
  choiceList() {
    // pd 确认这个是否可取消选择
    if(this.item.active) return
    if(this.propertyItem && !this.propertyItem.isMultipleChoice) {
      this.__singleSelect(false, true)
      this.item.count = 1;
    }else {
      if(!this.item.active) {
        this.item.active = true;
        this.item.count = 1;
      }
    }

  }


  

 

}




export default specialUtil;


// WEBPACK FOOTER //
// ./../../plugins/utils/specialUtil.js